import React from "react"
import { Box } from "@mui/material"

import Filter from "components/Algolia/Filters/Filter"

import { FilterConfig } from "@secureo/common/typings/Algolia"
import { SearchState } from "react-instantsearch-core"

const DesktopFilters = ({ filters }: Props) => {
	return (
		<Box mt={1}>
			{filters.map((filterConfig) => {
				const { attribute } = filterConfig

				return <Filter key={attribute} filterConfig={filterConfig} />
			})}
		</Box>
	)
}

interface Props {
	filters: FilterConfig[]
	virtualRefinements: SearchState
}

export default DesktopFilters
